import React, { useState, useCallback } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "../../../shared/components/Modal";
import Selecao from "../../../shared/components/Selecao";
import { MODAL_BACKGROUND_COLOR, SECONDARY_COLOR } from "../../../theme";
import { TIPO_CONSERVACAO_AMOSTRA } from "../../../shared/utils/Constantes";
import EtiquetaImpressaoManager from "../EtiquetaImpressaoManager";

export const ModalSelecionarConsevercao = (props) => {
  const classes = useStyles(props);
  const { modalAberto, fecharModal, idLote } = props;
  const [conservacao, setConservacao] = useState(TIPO_CONSERVACAO_AMOSTRA[0]);
  const [estaCarregando, setEstaCarregando] = useState(false);

  const salvarConservacao = async () => {
    setEstaCarregando(true);
    await EtiquetaImpressaoManager.salvarTipoConservacao(idLote, conservacao.id);
    setEstaCarregando(false);
    fecharModal();
  };

  return (
    <Modal
      modalAberto={modalAberto}
      desabilitarCliqueForaModal={false}
      iconeFechar={true}
      titulo={"Selecione o tipo de conservação"}
      maxWidth={"xs"}
      fecharModal={fecharModal}
      botaoPrincipal={{
        texto: "Salvar",
        acao: async () => await salvarConservacao(),
        desabilitado: false,
        carregando: estaCarregando,
      }}
      className={classes.modalSelecaoLaboratorio}
    >
      <Grid container className={"pr-2 pl-2 pt-2 pb-5"}>
        <Grid className={classes.gridSelecao} item xs={12}>
          <Selecao
            etiqueta="Selecione o tipo de conservação da amostra"
            id="SelecaoConservacao"
            opcoes={TIPO_CONSERVACAO_AMOSTRA}
            modal={true}
            codigo={conservacao.codigo}
            retornarObjetoCompleto={true}
            handleChange={(_, value) => {
              setConservacao(value);
            }}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

const useStyles = makeStyles({
  root: {
    backgroundColor: MODAL_BACKGROUND_COLOR,
    paddingBottom: "35px",
    paddingTop: "15px",
  },
  corPrimariaProgresso: {
    backgroundColor: SECONDARY_COLOR,
  },
  tituloModal: {
    fontWeight: "bold",
    textAlign: "center",
    paddingBottom: "15px",
  },
  barraProgresso: {
    marginLeft: "24px",
    marginRight: "24px",
  },
  paperWidthXs: {
    width: "350px",
  },
});

export default ModalSelecionarConsevercao;
